module.exports = __webpack_public_path__ + "static/media/Move Up Red.7192616b.svg";